export default function (theme) {
    return {
        MuiSwitch: {
            styleOverrides: {
                root: {
                    color: theme.palette.primary.main
                },
                colorSecondary: {
                    '&.Mui-checked': {
                        color: theme.palette.secondary.dark,
                        // '& + $bar': {
                        //     backgroundColor: theme.palette.secondary.dark
                        // }
                    },
                },
            }
        }
    };
}